// import assest from '@/json/assest'
import assest from '../../json/assest'
import { Box, Button, Checkbox, Dialog, FormControlLabel, FormGroup, List, ListItem } from '@mui/material'
// import Image from 'next/image'
// import styles from "@/styles/components/displayRelease.module.scss"
import styles from "../../styles/components/displayRelease.module.scss"
import React from 'react'

const DisplayRelease = () => {
    return (
        <Box className="filterModalWrapper filterModalWrapperDisplay">
            <Box className="filterModalHeader">
                <h4>Display released videos for:</h4>
                <Button>
                    <img src={assest.resetIcon} width={9} height={9} alt="" />
                    <p>Clear</p>
                </Button>
            </Box>

            <Box className="filterModalBody">
                <Box className={styles.displayReleaseWrapper}>
                    <Box className={styles.messageModalBody}>
                        <Box className={styles.videoReleaseBox}>
                            <Box className={styles.videoReleseBosItem}>
                                <img src={assest.copyRighticon} width={43} height={43} alt='' />
                                <h4>Copyright Dispute</h4>
                            </Box>
                            <Box className={`${styles.videoReleseBosItem} ${styles.videoReleseBosItemActive}`}>
                                <img src={assest.somethingElseIcon} width={43} height={43} alt='' />
                                <h4>Copyright Dispute</h4>
                            </Box>
                        </Box>
                    </Box>

                    <Box className={styles.releaseCheckBox}>
                        <h4>Released to: <img src={assest.resetIconBlue} width={9} height={9} alt='' /></h4>
                        <List>
                            <ListItem>
                                <FormGroup>
                                    <FormControlLabel required control={<Checkbox />} label="ViralHog" />
                                </FormGroup>
                            </ListItem>
                            <ListItem>
                                <FormGroup>
                                    <FormControlLabel required control={<Checkbox />} label="Jukin Media" />
                                </FormGroup>
                            </ListItem>
                            <ListItem>
                                <FormGroup>
                                    <FormControlLabel required control={<Checkbox />} label="CollabDRM" />
                                </FormGroup>
                            </ListItem>
                            <ListItem>
                                <FormGroup>
                                    <FormControlLabel required control={<Checkbox />} label="Newsflare" />
                                </FormGroup>
                            </ListItem>
                            <ListItem>
                                <FormGroup>
                                    <FormControlLabel required control={<Checkbox />} label="Storyful" />
                                </FormGroup>
                            </ListItem>
                        </List>
                    </Box>
                </Box>
            </Box>

            <Box className="filterModalFooter">
                <Box className="buttonGroup">
                    <Button>Cancel</Button>
                    <Button className="activeButton">
                        Filter now
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default DisplayRelease